import axios from 'axios'
import * as utils from './apiUtils'

const radius = 20

export default {
  getPoles(lat, lon) {
    return axios.get(utils.getApiUrl('/poles/get_poles'), {
      params: { lat, lon, radius }
    })
  },
  getPolesByLocations(locations) {
    return axios.get(utils.getApiUrl('/poles/get_poles_by_locations'), {
      params: { locations }
    })
  },
  getJoints(lat, lon) {
    return axios.get(utils.getApiUrl('/joints/get_joints'), {
      params: { lat, lon, radius }
    })
  },
  getJointsByLocations(locations) {
    return axios.get(utils.getApiUrl('/joints/get_joints_by_locations'), {
      params: { locations }
    })
  },
  getJointDistance(id, lat, lon) {
    return axios.get(utils.getApiUrl('/joints/get_joint_distance'), {
      params: { joint_id: id, lat, lon }
    })
  },
}
